<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div></div>
  <button class="button-ghost" (click)="createGift()">Create Gifts</button>
</div>
